import React from "react";

const CustomSwitch = ({ checked, onChange, disabled, loading }) => {
  const handleToggle = () => {
    if (disabled) return;
    onChange(!checked);
  };

  const switchStyles = {
    width: "40px",
    height: "20px",
    borderRadius: "12px",
    backgroundColor: checked ? "#06513D" : "#d9d9d9",
    display: "flex",
    alignItems: "center",
    justifyContent: checked ? "flex-end" : "flex-start",
    padding: "1px",
    cursor: disabled ? "not-allowed" : "pointer",
    opacity: disabled ? 0.6 : 1,
    position: "relative",
    transition: "all 0.3s ease",
  };

  const toggleStyles = {
    width: "16px",
    height: "16px",
    backgroundColor: "#fff",
    borderRadius: "50%",
    position: "relative",
  };
  const crossStyles = {
    position: "absolute",
    top: "50%",
    left: "10px",
    transform: "translateY(-50%)",
    color: "#fff",
    fontSize: "16px",
    visibility: checked ? "visible" : "hidden",
  };

  return (
    <div style={switchStyles} onClick={handleToggle}>
      <span style={crossStyles}>×</span>
      <div style={toggleStyles}></div>
    </div>
  );
};

export default CustomSwitch;
